// Do not delete this component, it's used by starter packs
// If changed, let the starter pack team know
import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"

import * as actions from "./actions"

import Indicators from "./components/Indicators"
import IndicatorDetail from "./components/IndicatorDetail"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    startIndicatorDetail: (
        element: HTMLElement | undefined | null,
        indicatorId: number,
    ) => void
    startDashboardIndicators: (
        element: HTMLElement | undefined | null,
        indicatorSchemeId: number,
    ) => void
    startWorkspaceIndicators: (
        element: HTMLElement | undefined | null,
        indicatorId: number,
    ) => void
    updateIndicatorSchemeId: (indicatorSchemeId: number) => void
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const startIndicatorDetail = (
        element: HTMLElement | undefined | null,
        indicatorId: number,
    ): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        store.dispatch(actions.requestIndicator(indicatorId))

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <IndicatorDetail />
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    const startIndicators = (
        element: HTMLElement | undefined | null,
        indicatorId: number,
        indicatorSchemeId: number,
    ): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        store.dispatch(
            actions.requestIndicators(indicatorId, indicatorSchemeId),
        )

        if (element) {
            const root = createRoot(element)
            root.render(
                <Provider store={store}>
                    <OldUIContext.Provider value={oldUIContext}>
                        <OldUIContext.Consumer>
                            {(): JSX.Element => <Indicators />}
                        </OldUIContext.Consumer>
                    </OldUIContext.Provider>
                </Provider>,
            )
        }
    }

    const startDashboardIndicators = (
        element: HTMLElement | undefined | null,
        indicatorSchemeId: number,
    ): void => startIndicators(element, 0, indicatorSchemeId)

    const startWorkspaceIndicators = (
        element: HTMLElement | undefined | null,
        indicatorId: number,
    ): void => startIndicators(element, indicatorId, 0)

    const updateIndicatorSchemeId = (indicatorSchemeId: number): void => {
        store.dispatch(actions.requestIndicators(0, indicatorSchemeId))
    }

    return {
        startIndicatorDetail,
        startDashboardIndicators,
        startWorkspaceIndicators,
        updateIndicatorSchemeId,
    }
}

export default init
